import { Link } from "gatsby";
import React from "react";

function PTLFooter() {
  return (
    <footer style={{
      background: "#0f172a",
      padding: "32px 0",
      textAlign: "center",
      fontFamily: "'Poppins', sans-serif",
    }}>
      <div className="container">
        <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
          &copy; {new Date().getFullYear()} Prozo. All rights reserved. &nbsp;|&nbsp; Enkay Tower, Udyog Vihar Phase V, Gurugram, Haryana
        </p>
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: 24,
          marginTop: 10,
        }}>
          <Link to="/privacy-policy" style={{ fontSize: 13, color: "#94a3b8" }}>
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" style={{ fontSize: 13, color: "#94a3b8" }}>
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default PTLFooter;
